import { FC } from 'react'

import { CrossSellCard } from './CrossSellCard'
import { useCrossSell } from './useCrossSell'
import {
  BONUS_PLATFORMS,
  CrossSellPlatform,
  crossSellPairs,
  getBonusCtaText,
} from './helpers'

import { CardsRow } from './styles'

interface Props {
  currentPlatform: CrossSellPlatform
  isBonusActive?: boolean
  bonusAmount?: number
}

export const CrossSellSuccessBlock: FC<Props> = ({
  currentPlatform,
  isBonusActive = false,
  bonusAmount = 0,
}) => {
  const { onCreateCampaign } = useCrossSell()
  const platforms = crossSellPairs[currentPlatform]

  return (
    <CardsRow>
      {platforms.map((platform) => {
        const hasBonus = isBonusActive && BONUS_PLATFORMS.includes(platform)

        return (
          <CrossSellCard
            key={platform}
            platform={platform}
            ctaText={hasBonus ? getBonusCtaText(platform, bonusAmount) : null}
            onClick={() => onCreateCampaign(platform)}
          />
        )
      })}
    </CardsRow>
  )
}
